import { render, staticRenderFns } from "./bottomBox.vue?vue&type=template&id=dd477a80&scoped=true"
import script from "./bottomBox.vue?vue&type=script&lang=js"
export * from "./bottomBox.vue?vue&type=script&lang=js"
import style0 from "./bottomBox.vue?vue&type=style&index=0&id=dd477a80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd477a80",
  null
  
)

export default component.exports